import React from 'react';

export default ({ value, name, type, onChange, large }) => {
  const Input = large ? 'textarea' : 'input';
  return (
    <Input value={value} name={name} type={type} className="form-control" onChange={onChange} />
  );
};
